"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _rcTimePicker = _interopRequireDefault(require("rc-time-picker"));
require("rc-time-picker/assets/index.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TimePicker = require("./TimePicker.styled");
var TimePicker = exports.TimePicker = function TimePicker(_ref) {
  var id = _ref.id,
    dataTestId = _ref.dataTestId,
    showSecond = _ref.showSecond,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    format = _ref.format,
    placeholder = _ref.placeholder,
    use12Hours = _ref.use12Hours,
    inputReadOnly = _ref.inputReadOnly;
  return _react["default"].createElement(_TimePicker.Wrapper, {
    "data-testid": dataTestId
  }, _react["default"].createElement(_rcTimePicker["default"], {
    id: id,
    showSecond: showSecond,
    defaultValue: defaultValue,
    onChange: onChange,
    format: format,
    placeholder: placeholder,
    use12Hours: use12Hours,
    inputReadOnly: inputReadOnly
  }));
};
TimePicker.propTypes = {
  dataTestId: _propTypes["default"].string,
  id: _propTypes["default"].string,
  showSecond: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  format: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  use12Hours: _propTypes["default"].bool,
  inputReadOnly: _propTypes["default"].bool
};
TimePicker.defaultProps = {
  format: 'h:mm a',
  placeholder: _momentTimezone["default"].utc().hours(9).format('h:mm a')
};